import { z as zod } from 'zod';
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { DetailSchema, RelatedInfoSchema } from "@/app/features/shared/types/schema";

const SiteCityCuratorArchaeologyDetailSchema = DetailSchema.omit({ id: true });

export const SiteCityCuratorArchaeologySchema = zod.object({
    title: zod.string().min(1, 'Title is required'),
    subtitle: zod.string(),
    details: zod.array(SiteCityCuratorArchaeologyDetailSchema),
    additionalIntroImages: zod.array(MediaRefSchema),
    relatedInfos: zod.array(RelatedInfoSchema),
});
